import axios from "axios";
import toast from "react-hot-toast";
import $ from "jquery";

export function searchValoracion(id, list, setvalSelected) {
  setvalSelected(list.find((x) => x.ratingId === id));
}

export const EditarValoracion = (values, reset, setflag, flag) => {
  let valoracion = {
    ratingId: values.ratingId,
    companyId: values.companyProfileId,
    title: values.title,
    description: values.description,
  };

  axios.post("company-ratings/update", valoracion).then((result) => {
    if (result.status === 200) {
      toast.success("Se ha agregado exitosamente!", {
        duration: 6000,
      });
      $("#crear-editar-acercade-modal").modal("hide");
      reset();
      setflag(flag ? false : true);
    }
  });
};

export const EliminarValoracion = (id, setflag, flag) => {
  axios.post("company-ratings/delete/" + id).then((result) => {
    if (result.status === 200) {
      toast.success("Se ha agregado exitosamente!", {
        duration: 6000,
      });
      $("#elimnar-valoracion-modal").modal("hide");
      setflag(flag ? false : true);
    }
  });
};
